/**
 * AllMail created by johnmc on 05/11/17.
 */
import { Component, Input, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'all-messages',
  template: `<sub-menu [options]="subMenu"></sub-menu><messages></messages>`,
  styles: [],
})

export class AllMessagesComponent implements OnInit {
  @Input()
  errorMessage: string;
  subMenu: SubMenuOption[];

  constructor() {
    this.subMenu = [
      {route: '/messages', title: 'Messages'},
      {route: '/newmessage', title: 'New Message'},
    ];
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    AppComponent.SetTitle('Messages');
  }

}
